import { Reveal, SectionHeading } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

const ABOUT_IMG =
  "https://customer-assets-agu9un31.emergentagent.net/job_carpenter-pro-forte/artifacts/6yccejj8_WhatsApp%20Image%202026-09-13%20at%2007.08.18.jpeg";

export default function ChiSiamo() {
  const { t } = useLang();
  const a = t.about;

  return (
    <section id="chi-siamo" data-testid="about-section-container" className="relative py-28 lg:py-36">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-2 lg:gap-20 lg:px-10">
        <div>
          <SectionHeading
            overline={a.overline}
            title={a.title}
            testid="about-section-title"
          />
          <Reveal delay={0.1}>
            <p className="text-base leading-relaxed text-[#94A3B8]">
              <strong className="font-semibold text-[#F8FAFC]">Forte Servizii SRLS</strong> {a.p1}
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-5 text-base leading-relaxed text-[#94A3B8]">{a.p2}</p>
          </Reveal>
          <div className="mt-12 grid grid-cols-2 gap-px bg-[#272B36]">
            {a.stats.map((s, i) => (
              <Reveal key={s.label} delay={0.1 + i * 0.08} className="bg-[#14161C] p-6">
                <p className="font-display text-3xl font-bold uppercase text-[#F97316]">{s.value}</p>
                <p className="mt-2 text-xs leading-snug text-[#64748B]">{s.label}</p>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.15} className="relative">
          <div className="absolute -left-4 -top-4 h-full w-full border border-[#E65100]/40" aria-hidden="true" />
          <div className="relative overflow-hidden border border-[#272B36]">
            <img
              src={ABOUT_IMG}
              alt={a.imgAlt}
              className="h-[420px] w-full object-cover lg:h-[560px]"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0D0E11]/80 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 flex items-center gap-3 border-t border-r border-[#272B36] bg-[#0D0E11]/90 px-5 py-3 backdrop-blur">
              <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-[#22c55e]" />
              <span className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-[#94A3B8]">
                {a.caption}
              </span>
            </div>
          </div>
          <div className="hazard-stripes absolute -bottom-4 right-8 h-3 w-40" aria-hidden="true" />
        </Reveal>
      </div>
    </section>
  );
}
